import axios from 'axios';
import config from './index';

export default async function() {
  const url = `${process.env.PUBLIC_URL}/config.json`;
  try {
    const response = await axios.get(url);
    Object.assign(config, response.data || {});
  } catch {
    // intentionally ignoring errors.
    // default config will continue to be used.
  }
}
